<template>
  <div v-loading="typeLoading || instrumentLoading || groupLoading">
    <!-- 上傳 .xlsx 檔案按鈕 -->
    <div class="button-container">
      <el-upload
        :show-file-list="false"
        accept=".xlsx"
        :before-upload="handleFileUpload"
      >
        <el-button type="primary">{{$t('manual.uploadXlsx')}}</el-button>
      </el-upload>
      <el-button @click="clearRow">{{$t('manual.clearRow')}}</el-button>
      <!--el-checkbox v-model="autoClearAfterUpload">上傳後自動清空</el-checkbox-->
      <el-button @click="dialogVisible = true">{{$t('manual.importUpload')}}</el-button>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span>
          {{ autoClearAfterUpload ? '確定上傳？' : '確定上傳？' }}
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadRow()">上傳</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </span>
      </el-dialog>

      <el-select v-model="download_link" :placeholder="$t('manual.selectTemplate')">
        <el-option
          v-for="item in dl_options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--el-cascader
        v-model="download_link"
        :options="dl_options"
        :props="{ expandTrigger: 'hover' }"
        :placeholder="$t('manual.selectTemplate')"
      >
      </el-cascader-->

      <el-button
        v-if="download_link"
        @click="handleDownload"
      >
        {{$t('manual.templateDownload')}}
      </el-button>
      <el-tag 
        v-if="validationErrors.length > 0" 
        type="danger"
        size="small"
      >
        {{ validationErrors.length }} 個錯誤
      </el-tag>
      <el-tag 
        v-else-if="rows.filter(r => r.enabled).length > 0" 
        type="success"
        size="small"
      >
        ✓ 驗證通過
      </el-tag>
    </div>
    <!-- 列表顯示區 -->
    <el-table 
      :data="rows" 
      :row-class-name="({row, rowIndex}) => hasError(rowIndex) ? 'error-row' : ''"
      style="width: 100%; margin-top: 20px; " 
      border
    >
      <el-table-column label="啟用" width="80">
        <template #default="scope">
          <el-checkbox 
            v-model="scope.row.enabled" 
            :disabled="!scope.row.canEdit"
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column label="分頁選單" width="120">
        <template #default="scope">
          <el-select v-model="scope.row.sheetName" @change="getInstrumentData(scope.row.sheetName)" placeholder="選擇分頁">
            <el-option
              v-for="sheet in sheetNames"
              :key="sheet"
              :label="sheet"
              :value="sheet"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="時間" width="140">
        <template #default="scope">
          {{ scope.row.timestamp }}
        </template>
      </el-table-column>
      <el-table-column label="內容">
        <template #default="scope">
          <div v-if="scope.row.group && scope.row.datas.length>0">
            <el-table :data="scope.row.datas" border style="width: 100%" size="mini">
              <el-table-column
                prop="depth"
                label="深度(m)"
              >
              </el-table-column>
              <el-table-column
                v-for="(value, key) in SIS_header"
                :key="key"
                :label="value.name"
                :prop="value.name"
              >
              </el-table-column>
            </el-table>
          </div>
          <div v-else-if="scope.row.datas.length>0">
            <el-table :data="scope.row.datas" border style="width: 100%" size="mini">
              <el-table-column
                v-for="(value, key) in Object.keys(scope.row.datas[0])"
                :key="key"
                :label="value"
              >
                <template #default="scope_cell">
                  <div :class="warning(scope.row, scope_cell.$index, value)">
                    {{ scope_cell.row[value] }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="儀器" width="200">
        <template #default="scope">
          <div v-for="(value, key) in scope.row.instruments" :key="key">
            {{ value ? value.name : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="人工量測數據" width="200">
        <template #default="scope">
          <table>
            <tbody>
              <!--tr v-for="(value, key) in scope.row.reading" :key="key">
                {{ value ? (`${value['A+'] ? `${value['A+']} / ${value['A-']}` : value.reading1 ? value.reading1 : '-'} / ${value.reading3 ? value.reading3 : '-'}`) : "-" }}
              </tr-->
              <tr v-for="(value, key) in scope.row.reading" :key="key">
                <template v-if="value && value.readings">
                  G1: {{ showVal(value && value.readings ? value.readings.Gate1 : null) }},
                  G2: {{ showVal(value && value.readings ? value.readings.Gate2 : null) }},
                  G3: {{ showVal(value && value.readings ? value.readings.Gate3 : null) }}
                </template>
                <template v-else>
                  {{
                    value
                      ? (`${value['A+'] ? `${value['A+']} / ${value['A-']}` : (showVal(value && value.reading1)) } / ${(showVal(value && value.reading3))}`)
                      : '-'
                  }}
                </template>
              </tr>
            </tbody>
          </table>
        </template>
      </el-table-column>
      <!--el-table-column label="操作" width="100">
        <template #default="scope">
          <el-button @click="uploadRow(scope.row)">上傳</el-button>
        </template>
      </el-table-column-->
    </el-table>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
const ExcelJS = require('exceljs');
import { EDIT_PASS_TABLE } from '@/constants/userRoles';
import { TemplateDownloadLinkCascaderOption, TemplateDownloadLinkSelectOption } from '@/constants/instrumentTemplateDLOption';
import manualProjectMixin from '@/lib/base/manualProject';

export default {
  mixins: [manualProjectMixin],
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    userRole() {
      return this.$store.getters['user/details'].roles;
    },
    editPass() {
      return !!EDIT_PASS_TABLE[this.userRole];
    },
  },
  data() {
    return {
      dialogVisible: false,
      sheetNames: [], // 存放 xlsx 文件中的所有分頁名稱
      rows: [], // 列表，預設有一行
      originInstrumentList: [],
      stationsList: [],
      instrumentTypeList: [],
      workbook: null,
      instrumentLoading: false,
      typeLoading: false,
      groupLoading: false,
      sheet_printArea: {},
      instrumentGroupList: [],
      SIS_header: [
        {col:2, name: '初始值A+'},
        {col:3, name: '初始值A-'},
        {col:4, name: '觀測值A+'},
        {col:5, name: '觀測值A-'},
        {col:6, name: '變化量'  },
        {col:7, name: '位移量'  },
        {col:8, name: '備註'    },
      ],
      ELP_header: [
        {col:1, name: '裝設深度'},
        {col:2, name: '變換係數'},
        {col:3, name: '初始值'  },
        {col:4, name: '觀測值', reading1: true},
        {col:5, name: '水壓力', reading3: true},
      ],
      LC_header: [
        // A欄是「儀器編號」，所以從 B 欄開始 col:1
        { col: 1, name: 'Gate1 初值', gateInitial: 1 }, // 可選：若你的模板有初值欄
        { col: 2, name: 'Gate2 初值', gateInitial: 2 },
        { col: 3, name: 'Gate3 初值', gateInitial: 3 },

        { col: 5, name: 'Gate1 讀值', gateReading: 1 },
        { col: 6, name: 'Gate2 讀值', gateReading: 2 },
        { col: 7, name: 'Gate3 讀值', gateReading: 3 },

        { col: 8, name: '平均軸力', reading3: true},

        { col: 9, name: '備註', remark: true }, // 你要不要吃 remark 看需求
      ],
      autoClearAfterUpload: true,

      currentUploadFile: null,

      dl_options: TemplateDownloadLinkSelectOption,
      download_link: '',
      validationErrors: [], // 儲存驗證錯誤
    };
  },
  mounted(){
    console.log('use KMRT-Import');
    this.getGroup();
    this.getInstrumentTypeList();
    this.getInstruments();
  },
  methods: {
    // 用於創建一個空白行
    createEmptyRow() {
      return {
        text: '', // 預設空白文字
        sheetName: '', // 預設沒有選擇分頁
        datas: [],
        timestamp: '',
        station: null,
        instruments: [],
        reading: [],
        enabled: false,
        canEdit: false,
      };
    },
    // 處理文件上傳
    handleFileUpload(file) {
      // 儲存原始檔案,稍後上傳到後端
      this.currentUploadFile = file;
  
      const reader = new FileReader();
      reader.onload = async (e) => {
        this.$notifySuccess('載入成功');
        const workbook_2 = new ExcelJS.Workbook();
        await workbook_2.xlsx.load(e.target.result);
        workbook_2.eachSheet((worksheet, sheetId) => {
          const printArea = worksheet.pageSetup.printArea;

          console.log(`Sheet: ${worksheet.name}`);
          if (printArea) {
            console.log(`列印範圍: ${printArea}`);
            this.sheet_printArea[worksheet.name] = printArea;
          } else {
            console.log('沒有設置列印範圍');
          }
        });

        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array', cellStyles: true });
        const sheetsInfo = workbook.Workbook.Sheets;
        this.sheetNames = workbook.SheetNames.filter(sheetName => {
          const sheet = sheetsInfo.find(info => info.name === sheetName);
          return sheet && sheet.Hidden == 0; // 檢查是否為隱藏分頁
        });
        this.workbook = workbook;
        this.autoLoadAllTable();
      };
      reader.readAsArrayBuffer(file);
      return false; // 阻止默認的上傳行為
    },
    // 新增一行至列表
    addRow() {
      this.rows.push(this.createEmptyRow());
    },
    clearRow() {
      this.rows = [];
    },
    autoLoadAllTable(){
      let rowCount = this.rows.length - 1;
      let rowCounter = this.rows.length;

      // === 新增:收集解析結果 ===
      const parseResults = {
        success: [],
        failed: [],
      };

      for(let sheet of this.sheetNames){
        if(rowCount < rowCounter){
          this.addRow();
          rowCount++;
        }
  
        this.rows[rowCount].sheetName = sheet;
  
        // === 修改:接收回傳結果 ===
        const result = this.getInstrumentData(sheet);
  
        if(result.success){
          let row = this.rows[rowCount];
          if(row.instrument_type){
            rowCounter++;
            parseResults.success.push(sheet);
          }
          else{
            // 有資料但沒有對應的儀器類型
            this.$set(this.rows, rowCount, this.createEmptyRow());
            parseResults.failed.push({
              sheet,
              reason: '找不到對應的儀器類型',
            });
          }
        }
        else{
          // 解析失敗
          this.$set(this.rows, rowCount, this.createEmptyRow());
          parseResults.failed.push({
            sheet,
            reason: result.error,
            details: result.details,
          });
        }
      }

      // === 新增:根據結果顯示對應訊息 ===
      this.showParseResults(parseResults);

      this.$nextTick(() => {
        const validation = this.validateUploadData();
        if (!validation.valid) {
          this.$notify({
            title: '資料驗證警告',
            message: `發現 ${validation.errors.length} 個錯誤,請在上傳前修正`,
            type: 'warning',
            duration: 5000,
          });
        }
      });
    },

    showParseResults(results){
      const successCount = results.success.length;
      const failedCount = results.failed.length;

      // 情況一:全部失敗
      if(successCount === 0 && failedCount > 0){
        this.$notifyError('匯入錯誤,請重新確認格式');
        console.error('所有資料表都無法解析:', results.failed);
        return;
      }

      // 情況二:全部成功
      if(failedCount === 0){
        this.$notifySuccess(`成功載入 ${successCount} 個資料表`);
        return;
      }

      // 情況三:部分成功,部分失敗
      const failedSheets = results.failed.map(f => f.sheet).join('、');

      this.$notify({
        title: '部分資料表載入成功',
        message: `成功: ${successCount} 個\n失敗: ${failedCount} 個\n\n無法使用的資料表: ${failedSheets}`,
        type: 'warning',
        duration: 5000,
        dangerouslyUseHTMLString: false,
      });

      // 在 console 輸出詳細錯誤資訊供開發者查看
      console.warn('部分資料表解析失敗:', results.failed);
    },

    async uploadCheck(){

      const validation = this.validateUploadData();
  
      if (!validation.valid) {
        const errorMessage = this.formatValidationErrors(validation.errors);

        // 顯示詳細錯誤訊息
        await this.$alert(errorMessage, '資料驗證失敗', {
          type: 'error',
          confirmButtonText: '確定',
          dangerouslyUseHTMLString: false,
        });

        // 在 console 輸出詳細錯誤供開發者查看
        console.error('驗證錯誤詳情:', validation.errors);

        return; // 中止上傳
      }

      let outputs = [];

      for (let row of this.rows) {
        // 新增過濾條件
        if (!row.enabled || !row.timestamp) continue;

        for (let reading of row.reading) {
          if (!reading || !reading.instrument) continue;

          outputs.push({
            instrumentName: reading.instrument.name,
            reading: reading.reading1,
            'A+': reading['A+'],
            'A-': reading['A-'],
          });
        }
      }

      if (outputs.length === 0) {
        this.$message.warning('沒有可上傳的資料');
        return;
      }

      // 呼叫檢查 API
      const result = await this.$axios({
        category: 'manual',
        method: 'post',
        apiName: 'uploadOutputChecking',
        data: {
          outputs,
          // === 修改:使用第一個 enabled 的 row 的時間 ===
          date: this.rows.find(r => r.enabled && r.timestamp)?.timestamp,
          project: this.manualProjectId,
        },
      });

      if (!result?.data || result?.data?.error) {
        console.error(result?.data?.error);
        this.$message.error('發生錯誤');
        return;
      }

      const exist_instruments = result?.data?.exist_instruments;

      if (exist_instruments.length === 0) {
        return this.executeUpload();
      }

      let ins_str = '';
      for (let instrument_name of exist_instruments) {
        ins_str += '\n' + instrument_name;
      }

      if(this.editPass){
        try {
          await this.$confirm(
            `確認到重覆上傳,共有${exist_instruments.length}筆資料重複,\n請確認是否覆蓋:${ins_str}`,
            '資料重複',
            { 
              type: 'warning', 
              confirmButtonText: '確認覆蓋',
              cancelButtonText: '取消', 
            },
          );
        } catch {
          this.$message.info('已取消上傳');
          return;
        }

        return this.executeUpload();
      }

      this.$alert(
        `確認到重覆上傳，共有${exist_instruments.length}資料重複，\n請檢察，${ins_str}`,
        '資料重複', 
        { confirmButtonText: '確定' },
      );
    },

    async executeUpload() {
      // 上傳原始檔案
      if (this.currentUploadFile) {
        try {
          const formData = new FormData();
          formData.append('file', this.currentUploadFile);
          formData.append('uploadType', 'manual_instrument_data');
          formData.append('timestamp', new Date().toISOString());
          
          await this.$axios({
            method: 'post',
            apiName: `/project/${this.manualProjectId}/file`,
            data: formData,
          });
          
          console.log('原始檔案已上傳封存');
        } catch (error) {
          console.error('檔案上傳失敗:', error);
          this.$message.warning('檔案封存失敗,但將繼續上傳資料');
        }
      }
    
      let data = this.rows
        .filter(ele => ele.enabled && ele.timestamp) // 過濾條件
        .map(ele => {
          return {
            timestamp: ele.timestamp,
            instrument_data: ele.reading.filter(reading => reading),
          };
        });
    
      console.log('即將上傳的資料:', data);
    
      await this.$axios({
        category: 'manual',
        method: 'put',
        apiName: 'importManualOutput',
        data,
      });
    
      this.$notifySuccess('上傳成功');
    
      if (this.autoClearAfterUpload) {
        this.clearRow();
        this.currentUploadFile = null; // 清空檔案參考
      }
    },

    // 上傳行內容
    uploadRow() {
      //this.dialogVisible = false;
      //let data = this.rows.map(ele=>{
      //  return {
      //    timestamp: ele.timestamp,
      //    instrument_data: ele.reading.filter(reading=>reading),
      //  };
      //}).filter(ele=>ele.timestamp);
      //
      //console.log(data);
      //
      //this.$axios({
      //  category: 'manual',
      //  method: 'put',
      //  apiName: 'importManualOutput',
      //  data,
      //}).then(this.$notifySuccess('上傳成功'));
      //
      //if (this.autoClearAfterUpload) {
      //  this.clearRow();
      //}

      this.dialogVisible = false;
      // 改成呼叫 uploadCheck
      this.uploadCheck();
    },

    // 讀取所有儀器類型
    async getInstrumentTypeList(){
      this.typeLoading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: 'instrument_type',
      });
      this.instrumentTypeList = res.data.filter(ele => ele.manual).map(ele=>{
        return {
          ...ele,
          value: ele.name,
          label: ele.name,
        };
      });
      this.typeLoading = false;

      console.log(this.instrumentTypeList);
    },
    // 讀取所有人工量測儀器
    async getInstruments(){
      this.instrumentLoading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrumentSummary/${this.manualProjectId}`,
      });
      this.originInstrumentList = res.data;
      this.stationsList = this.originInstrumentList.reduce((pre, cur)=>{
        let stationIndex = pre.findIndex(ele=>ele.station==cur.station);
        if(stationIndex >= 0){
          pre[stationIndex].instruments.push(cur);
        }
        else{
          pre.push({
            station: cur.station,
            instruments: [cur],
          });
        }
        return pre;
      },[]);
      //this.getInstrumentsData();
      console.log(this.stationsList);
      this.instrumentLoading = false;

      console.log(this.originInstrumentList);
    },
    async getGroup(){
      this.groupLoading = true;
      let res = await this.$store
        .dispatch('data/getProjectInstrumentGroupList', {
          projectId: this.manualProjectId,
        });
      this.instrumentGroupList = res;
      this.groupLoading = false;
    },
    getInstrumentData(sheetName){
      try{
        let rowindex = this.rows.findIndex(ele=>ele.sheetName === sheetName);
        const sheet = this.workbook.Sheets[sheetName];

        // 將分頁內容轉換為 JSON 格式
        let sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: false });
        let hiddenColumns = [];
        let hiddenRows = [];

        //console.log(sheetData);
        // 檢查合併的格
        if (sheet['!merges']) {
          console.log(this.$lodash.cloneDeep(sheet['!merges']));
          for(let merges of sheet['!merges']){
            let merges_data = sheetData[merges.s.r][merges.s.c];
            //console.log(merges.s.r, merges.s.c, merges.e.r, merges.e.c);
            //console.log(merges_data);
            if(merges_data){
              for(let row = merges.s.r; row <= merges.e.r; row++){
                //console.log(sheetData[row]);
                for(let col = merges.s.c; col <= merges.e.c; col++)
                {
                  if(sheetData[row])sheetData[row][col] = merges_data;
                }
                //console.log(sheetData[row]);
              }
            }
          }
        }

        // 檢查隱藏的欄
        if (sheet['!cols']) {
          hiddenColumns = sheet['!cols']
            .map((col, index) => (col && (col.hidden || (col?.wch === 0)) ? index : -1))
            .filter(index => index !== -1); // 僅保留隱藏欄的索引
        }

        console.log(sheet['!cols']);

        // 檢查隱藏的列
        if (sheet['!rows']) {
          hiddenRows = sheet['!rows']
            .map((row, index) => (row && row.hidden ? index : -1))
            .filter(index => index !== -1); // 僅保留隱藏列的索引
        }

        console.log(`get sheet print area: ${this.sheet_printArea[sheetName]}`);
        console.log(hiddenColumns);
        //let print_area = this.parsePrintArea(this.sheet_printArea[sheetName]);

        let print_area = this.getSheetRange(sheet, sheetName);

        //console.log(print_area);
        console.log(sheetData);

        sheetData = sheetData.filter((ele, index)=>{
          return !hiddenRows.includes(index) && index < print_area.bottom;
        });

        sheetData = sheetData.map(ele=>ele.reduce((pre,cur,curindex)=>{
          if(curindex < print_area.right) pre[curindex] = cur;
          return pre;
        },[]));

        //console.log(sheetData);

        let starter = 0;
        let headerIndex = sheetData.findIndex(ele=>{
          return ['編號','儀器編號'].includes(ele[starter]);
        });

        if(headerIndex<0){
          starter = 1;
          headerIndex = sheetData.findIndex(ele=>{
            return ['編號','儀器編號'].includes(ele[starter]);
          });
        }

        let depth_col = starter + 1;

        console.log(sheetData[headerIndex][depth_col], headerIndex, depth_col);
        //用於SIS(連續型儀器)
        if(sheetData[headerIndex][depth_col].includes('觀測深度')){
          let sub_headerIndex = headerIndex + 1;
          let firstIndex = sub_headerIndex + 1;
          let groupName = sheetData[firstIndex][0];
          this.getInstrumentGroupData(sheetName, sheetData, groupName, print_area, hiddenColumns);
        }
        //用於非連續型儀器
        else if(headerIndex >= 0){
          console.log(headerIndex);
          let sub_headerIndex = headerIndex + 1;
          let timestamp = this.trytomatchTimestamp(sheetData, starter);
          //let station = this.trytomatchStation(sheetName);
          //this.rows[rowindex].station = station;

          let datas = [];
          for(let index = sub_headerIndex + 1;index<sheetData.length;index++){
            if(!sheetData[index][0]) continue;
            console.log(sheetData[index]);
            datas.push({
              '儀器編號': sheetData[index][0],
            });
          }

          timestamp = this.convertExcelDate(timestamp);
          //console.log(datas);

          let instruments = this.trytomatchInstrument(datas);
          console.log(instruments);
          let instrument_type = instruments?.find(ele=>ele)?.instrument_type;
          //let header = null;
          //if(instrument_type.header_setting)  header = instrument_type.header_setting;
          //if(instrument_type?.name === 'ELP (水壓計)') header = this.ELP_header;
          let header = instrument_type?.header_setting || null;

          if (instrument_type?.name === 'ELP (水壓計)') header = this.ELP_header;

          // === LC 特例 ===
          if (this.isLCInstrumentType(instrument_type)) header = this.LC_header;

          //console.log('station', this.rows[rowindex].station);
          console.log('get instrument type', instrument_type);
          //console.log(sheetData);
          console.log('timestamp', timestamp);


          datas = datas.map((ele, index)=>{
            let skip = 0;
            let instrument_data = {};
            instrument_data = header.reduce((pre, cur, curindex)=>{
              while(hiddenColumns.includes(cur.col + skip)){
                skip++;
              }
              //console.log(starter, cur.col, skip);
              pre[cur.name] = sheetData[sub_headerIndex + 1 + index][starter + cur.col + skip];
              return pre;
            },{});
            return {
              ...ele,
              ...instrument_data,
            };
          });

          instruments = this.trytomatchInstrument(datas);

          console.log(datas);

          this.rows[rowindex].canEdit = true;
          this.rows[rowindex].enabled = true;
          this.rows[rowindex].timestamp = timestamp;
          this.rows[rowindex].datas = datas;
          this.rows[rowindex].instruments = instruments;
          this.rows[rowindex].instrument_type = instrument_type;

          let waring_check = this.check(datas, instrument_type);
          console.log(waring_check);
          this.rows[rowindex].warning_cell = waring_check;

          this.rows[rowindex].reading = this.rows[rowindex].instruments.map(ins=>{
            if(!ins) return null;

            // === LC ===
            if (this.isLCInstrumentType(instrument_type)) {
              const toNumOrNull = v => {
                const n = Number(v);
                return Number.isFinite(n) ? n : null;
              };

              const g1Header = header.find(h => h.gateReading === 1)?.name;
              const g2Header = header.find(h => h.gateReading === 2)?.name;
              const g3Header = header.find(h => h.gateReading === 3)?.name;

              const gi1Header = header.find(h => h.gateInitial === 1)?.name;
              const gi2Header = header.find(h => h.gateInitial === 2)?.name;
              const gi3Header = header.find(h => h.gateInitial === 3)?.name;

              const reading1_header = header.find(ele => ele.reading1)?.name;
              const reading3_header = header.find(ele => ele.reading3)?.name;

              const Gate1 = toNumOrNull(ins.xlsx_data[g1Header]);
              const Gate2 = toNumOrNull(ins.xlsx_data[g2Header]);
              const Gate3 = toNumOrNull(ins.xlsx_data[g3Header]);

              const Gate1initial = toNumOrNull(ins.xlsx_data[gi1Header]);
              const Gate2initial = toNumOrNull(ins.xlsx_data[gi2Header]);
              const Gate3initial = toNumOrNull(ins.xlsx_data[gi3Header]);

              const reading1 = ins.xlsx_data[reading1_header];
              const reading3 = ins.xlsx_data[reading3_header];

              return {
                instrument: ins,

                reading1,
                readings: { Gate1, Gate2, Gate3 },
                reading3,

                // 初值是否要從 Excel 上傳：可選
                // 若你要後端「以資料庫為準」，就可以不上傳或只當校驗用
                initials_from_xlsx: { Gate1: Gate1initial, Gate2: Gate2initial, Gate3: Gate3initial },
              };
            }

            let reading1_header = header.find(ele => ele.reading1)?.name;
            let reading3_header = header.find(ele => ele.reading3)?.name;
            let Aplus_header = header.find(ele => ele['A+'])?.name;
            let Aminus_header = header.find(ele => ele['A-'])?.name;
            //console.log(header);
            //console.log(header.find(ele => ele.reading1));
            //console.log(header.find(ele => ele.reading3));
            //console.log(reading1_header);
            //console.log(reading3_header);
            //console.log(ins.xlsx_data);
            let reading1 = ins.xlsx_data[reading1_header];
            let reading3 = ins.xlsx_data[reading3_header];
            let Aplus = ins.xlsx_data[Aplus_header];
            let Aminus = ins.xlsx_data[Aminus_header];
            reading1 = isNaN(Number(reading1)) ? NaN : reading1;
            reading3 = isNaN(Number(reading3)) ? NaN : reading3;
            return {
              instrument: ins,
              reading1,
              'A+': Aplus,
              'A-': Aminus,
              reading3,
            };
          });  
        }
        else{
          console.log('??');
        }

        console.log(this.rows);
        this.$forceUpdate();

        // === 新增:回傳成功狀態 ===
        return { success: true, sheetName };
      }
      catch(e){
        console.log(e);
    
        // === 修改:不要立即顯示錯誤,而是回傳失敗狀態 ===
        let errorMessage = '格式錯誤';
        if (e.message.includes('Invalid time value')){
          errorMessage = '時間格式錯誤';
        }

        return { 
          success: false, 
          sheetName, 
          error: errorMessage,
          details: e.message,
        };
      }
    },
    convertExcelDate(v, opts = {}) {
      const { use1904 = false } = opts;
    
      // 共用：本地格式化
      const pad = n => String(n).padStart(2, '0');
      const fmtLocal = d => {
        const yyyy = d.getFullYear();
        const MM   = pad(d.getMonth() + 1);
        const DD   = pad(d.getDate());
        const hh   = pad(d.getHours());
        const mm   = pad(d.getMinutes());
        return `${yyyy}-${MM}-${DD} ${hh}:${mm}`;
      };

      // 1) 直接是 Date
      if (v instanceof Date && !isNaN(v)) return fmtLocal(v);

      // 2) 數字或數字字串 → Excel 序列
      const isNumLike = (x) => (typeof x === 'number' && Number.isFinite(x)) ||
                               (typeof x === 'string' && /^\s*\d+(\.\d+)?\s*$/.test(x));
      if (isNumLike(v)) {
        const n = typeof v === 'number' ? v : parseFloat(v);
        const epoch = use1904 ? Date.UTC(1904, 0, 1) : Date.UTC(1899, 11, 30); // 1900 系統：含 1900/02/29 bug
        const ms = epoch + n * 86400000; // 天數含小數 → 毫秒
        const d = new Date(ms);
        if (!isNaN(d)) return fmtLocal(d);
      }
    
      // 3) 字串日期的寬鬆解析
      if (typeof v === 'string') {
        let s = v.trim();
        if (!s) return '';
    
        // 常見 "YYYY-MM-DD HH:mm[:ss]" → 補成 ISO 可解析
        if (/^\d{4}-\d{1,2}-\d{1,2}\s+\d{1,2}:\d{2}(:\d{2})?$/.test(s)) {
          s = s.replace(' ', 'T'); // 變 'YYYY-MM-DDTHH:mm[:ss]'
        }
    
        // 嘗試直接 new Date()
        let d = new Date(s);
        if (!isNaN(d)) return fmtLocal(d);

        // 退而求其次：自己拆（YYYY/MM/DD 或 YYYY-MM-DD 與可選時間）
        let m =
          s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/) ||
          s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})(?:[ T](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);

        if (m) {
          // 支援 YYYY-MM-DD 與 DD-MM-YYYY 兩種
          let Y, M, D, h = m[4] || 0, min = m[5] || 0, sec = m[6] || 0;
          if (m[1].length === 4) { // YYYY...
            [Y, M, D] = [Number(m[1]), Number(m[2]) - 1, Number(m[3])];
          } else {                 // DD...YYYY
            [Y, M, D] = [Number(m[3]), Number(m[2]) - 1, Number(m[1])];
          }
          d = new Date(Y, M, D, Number(h), Number(min), Number(sec));
          if (!isNaN(d)) return fmtLocal(d);
        }
      }

      // 4) 真的解析不了
      return '';
    },
    trytomatchTimestamp(sheetData, starter) {
      return (sheetData.find(ele=>{
        if(!ele[starter]) return false;
        if(ele[starter] && ((ele[starter].toString()).includes('本次觀測日期') || (ele[starter].toString()).includes('觀測日期'))){
          console.log('get ele',starter);
          console.log(ele);
          return true;
        }
        if(['TIMESTAMP','timestamp'].includes(ele[starter])) {
          console.log('get ele',starter);
          console.log(ele);
          return true;
        }
        return false;
      }))?.[starter+1];
    },
    trytomatchStation(sheetName) {
      const result = sheetName.replace(/\s+/g, '');
      for(let stationData of this.stationsList){
        //console.log(`${sheetName}-${stationData.station}`);
        if(result == stationData.station) return stationData;
      }
      console.log(`get no station name: ${result}`);
      return false;
    },
    trytomatchGroup(sheetName) {
      const result = sheetName.replace(/\s+/g, '');
      for(let group of this.instrumentGroupList){
        //console.log(group);
        if(result == group.name) return group;
      }
      console.log(`get no group name: ${result}`);
      return false;
    },
    trytomatchInstrument(datas){
      let instruments = [];
      for(let data of datas){
        let ins_index = this.originInstrumentList.findIndex(ele=>ele.name === data['儀器編號']);
        if(ins_index >= 0){
          instruments.push({
            ...this.originInstrumentList[ins_index],
            xlsx_data: data,
          });
        }
        else{
          instruments.push(null);
        }
      }
      return instruments;
    },

    // 新增統一的範圍取得方法
    getSheetRange(sheet, sheetName) {
      // 1. 嘗試使用列印範圍
      if (this.sheet_printArea[sheetName]) {
        try {
          const range = this.parsePrintArea(this.sheet_printArea[sheetName]);
          console.log(`📄 ${sheetName}: 使用列印範圍`);
          return range;
        } catch (error) {
          console.warn(`⚠️ ${sheetName}: 列印範圍解析失敗`, error);
        }
      }

      // 2. 嘗試使用 !ref
      if (sheet['!ref']) {
        try {
          const range = this.parseSheetRef(sheet['!ref']);
          console.log(`📊 ${sheetName}: 使用 !ref (${sheet['!ref']})`);
          return range;
        } catch (error) {
          console.warn(`⚠️ ${sheetName}: !ref 解析失敗`, error);
        }
      }

      // 3. 手動掃描
      try {
        const range = this.findDataRange(sheet);
        console.log(`🔍 ${sheetName}: 使用手動掃描`);
        return range;
      } catch (error) {
        console.error(`❌ ${sheetName}: 所有方法都失敗`, error);
        throw new Error('無法取得資料範圍');
      }
    },
    parsePrintArea(printArea) {
      if (!printArea || typeof printArea !== 'string') {
        throw new Error('Invalid print area');
      }
    
      // 拆解範圍，例如 "A1:B2"
      const [startCell, endCell] = printArea.split(':');
    
      // 解析單一儲存格的列和行
      const parseCell = (cell) => {
        const match = cell.match(/^([A-Z]+)(\d+)$/); // 解析格式，例如 "A1"
        if (!match) {
          throw new Error(`Invalid cell format: ${cell}`);
        }
      
        const column = match[1];
        const row = parseInt(match[2], 10);
      
        // 將列從字母轉為數字 (例如 A = 1, B = 2, ..., Z = 26, AA = 27)
        const columnNumber = column.split('').reduce((acc, char) => {
          return acc * 26 + (char.charCodeAt(0) - 64); // A 的 ASCII 為 65
        }, 0);
      
        return { column: columnNumber, row };
      };
    
      // 解析起始與結束儲存格
      const start = parseCell(startCell);
      const end = parseCell(endCell);
    
      return {
        left: start.column,
        right: end.column,
        top: start.row,
        bottom: end.row,
      };
    },
    // 方法1: 解析 SheetJS 的 !ref
    parseSheetRef(ref) {
      // ref 格式: "A1:Z100"
      const [startCell, endCell] = ref.split(':');

      const parseCell = (cell) => {
        const match = cell.match(/^([A-Z]+)(\d+)$/);
        if (!match) throw new Error(`Invalid cell format: ${cell}`);

        const column = match[1];
        const row = parseInt(match[2], 10);

        const columnNumber = column.split('').reduce((acc, char) => {
          return acc * 26 + (char.charCodeAt(0) - 64);
        }, 0);

        return { column: columnNumber, row };
      };

      const start = parseCell(startCell);
      const end = parseCell(endCell);

      return {
        left: start.column,
        right: end.column,
        top: start.row,
        bottom: end.row,
      };
    },

    // 方法2: 手動掃描資料範圍
    findDataRange(sheet) {
      let maxRow = 0;
      let maxCol = 0;

      // 掃描所有儲存格
      for (let cellAddress in sheet) {
        // 跳過特殊屬性 (以 ! 開頭)
        if (cellAddress[0] === '!') continue;

        // 解析儲存格位址 (例如 "A1", "AB123")
        const match = cellAddress.match(/^([A-Z]+)(\d+)$/);
        if (!match) continue;

        const col = match[1];
        const row = parseInt(match[2], 10);

        // 計算欄位數字
        const colNum = col.split('').reduce((acc, char) => {
          return acc * 26 + (char.charCodeAt(0) - 64);
        }, 0);

        maxRow = Math.max(maxRow, row);
        maxCol = Math.max(maxCol, colNum);
      }

      return {
        left: 1,
        right: maxCol,
        top: 1,
        bottom: maxRow,
      };
    },

    getInstrumentGroupData(sheetName, sheetData, groupName, print_area, hiddenColumns){
      let rowindex = this.rows.findIndex(ele=>ele.sheetName === sheetName);
      let starter = print_area.left - 1;
      let headerIndex = sheetData.findIndex(ele=>{
        return ['儀器編號'].includes(ele[starter]);
      });
      console.log(`try to match instrument group ${groupName}`);

      let sub_headerIndex = headerIndex + 1;
      //let sub_headerIndex2 = headerIndex + 2;

      let depth_array = sheetData.reduce((pre, cur, curindex)=>{
        if(curindex < sub_headerIndex + 1) return pre;
        if(!cur[starter + 1]) return pre;
        pre.push(cur[starter + 1]);
        return pre;
      },[]).sort((a, b) => Math.abs(b) - Math.abs(a));
      let depth_max = depth_array[0];

      if(headerIndex>=0) console.log('sheet-', groupName, 'found header in', headerIndex, 'found "深度"', depth_max);
      else return;

      let depth_col = starter + 1;

      if(!sheetData[headerIndex][depth_col].includes('觀測深度')) {
        console.log('sheet-', groupName, 'cannot find depth column', sheetData[headerIndex][depth_col]);
        return;
      }

      let datas = [];
      for(let i = sub_headerIndex + 1; i < sheetData.length; i++){
        let depth = Number(sheetData[i][depth_col]);
        if(isNaN(depth)) break;
        //let data = sheetData[i].slice(starter + 1, starter + 1 + 6);
        let skip = 0;
        datas.push({
          depth,
          ...(this.SIS_header.reduce((pre, cur, curindex)=>{
            while(hiddenColumns.includes(cur.col + skip)){
              skip++;
            }
            //console.log(starter, cur.col, skip);
            pre[cur.name] = sheetData[i][starter + cur.col + skip];
            return pre;
          },{})),
        });
        console.log('get depth',depth,'count',datas.length-1,'data:', datas[datas.length-1]);
      }

      let timestamp = this.trytomatchTimestamp(sheetData, starter);

      if(!timestamp) timestamp = this.trytomatchTimestamp(sheetData, starter+1);

      this.rows[rowindex].timestamp = this.convertExcelDate(timestamp);
      this.rows[rowindex].datas = datas;

      this.rows[rowindex].group = this.trytomatchGroup(groupName);
      //this.rows[rowindex].station = this.trytomatchStation(groupName);
      
      let depthType = this.rows[rowindex].group.instrumentList.every((ele)=>ele.depth<=0);
      //console.log(depthType);

      this.rows[rowindex].instruments = this.rows[rowindex].group && this.rows[rowindex].group.instrumentList.map(ele=>{
        let instrument = this.originInstrumentList.find(ins=>ins._id.toString() === ele.instrument.toString());
        if(!instrument) return undefined;
        let depth_data = datas.find(row=>Math.abs(row.depth) === (depthType ? Math.abs(ele.depth) : ele.depth));
        console.log(Math.abs(ele.depth), datas[0].depth, depth_data);
        return {
          ...instrument,
          depth_data,
        };
      });
      //console.log(this.rows[rowindex]);
      let instrument_type = this.rows[rowindex].instruments?.find(ele=>ele)?.instrument_type;
      this.rows[rowindex].instrument_type = instrument_type;
      this.rows[rowindex].reading = this.rows[rowindex].group && this.rows[rowindex].instruments.map(ins=>{
        if(!ins) return null;
        let reading1_A_plus  = ins.depth_data['觀測值A+'];
        let reading1_A_minus = ins.depth_data['觀測值A-'];
        let reading3 = ins.depth_data['位移量'];
        reading1_A_plus  = isNaN(Number(reading1_A_plus )) ? NaN : reading1_A_plus ;
        reading1_A_minus = isNaN(Number(reading1_A_minus)) ? NaN : reading1_A_minus;
        reading3 = isNaN(Number(reading3)) ? NaN : reading3;
        return {
          instrument: ins,
          'A+': reading1_A_plus,
          'A-': reading1_A_minus,
          reading3,
        };
      });
      this.rows[rowindex].canEdit = true;   // 讓 checkbox 不再 disabled
      this.rows[rowindex].enabled = true;   // 或者預設 false，看你的業務需求

    },
    check(datas, instrument_type){
      return datas.map(data=>{
        if(!instrument_type || !instrument_type.header_setting){
          return Object.keys(data).reduce((pre, cur)=>{
            pre[cur] = false;
            return pre;
          },{});
        }
        return instrument_type.header_setting.reduce((pre, cur)=>{
          //pre[cur.name] = false;
          pre[cur.name] = false;

          if(![null, undefined].includes(cur.lt)){
            console.log(pre[cur.name], data[cur.name] <= cur.lt);
            pre[cur.name] = pre[cur.name] || (data[cur.name] < cur.lt);
          }
          if(![null, undefined].includes(cur.gt)){
            console.log(pre[cur.name], data[cur.name] <= cur.gt);
            pre[cur.name] = pre[cur.name] || (data[cur.name] > cur.gt);
          }
          if(![null, undefined].includes(cur.lte)){
            console.log(pre[cur.name], data[cur.name] <= cur.lte);
            pre[cur.name] = pre[cur.name] || (data[cur.name] <= cur.lte);
          }
          if(![null, undefined].includes(cur.gte)){
            console.log(pre[cur.name], data[cur.name] <= cur.gte);
            pre[cur.name] = pre[cur.name] || (data[cur.name] >= cur.gte);
          }
          
          return pre;
        },{});
      });
    },
    warning(data, row, col){
      // 針對第二列，分數小於 60 的單元格變紅色
      //console.log('test',data);
      //console.log('test2', col, row);
      if (data?.warning_cell[row][col]) {
        //console.log('warning-cell');
        return 'warning-cell';
      }
      return '';
    },
    // 提取出錯行號的函數
    getErrorLine(error) {
      if (error.stack) {
        // 分析堆疊訊息中的行號
        const stackLines = error.stack.split('\n');
        const relevantLine = stackLines[1]; // 堆疊訊息中的第二行包含出錯位置
        const match = relevantLine.match(/:(\d+):\d+\)?$/); // 匹配行號
        if (match) {
          return parseInt(match[1], 10); // 返回行號
        }
      }
      return 'Unknown line'; // 如果無法解析行號
    },

    handleDownload() {
      const url = this.download_link;
      console.log(url);
      if (!url) return;

      // 作法 1：開新分頁下載
      //window.open(url, '_blank');

      // 若你不想開新分頁，而是直接觸發下載：
      //*
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      // a.download = ''; // 若後端 header 正常，可以加這行提示瀏覽器直接下載
      document.body.appendChild(a);
      a.click();
      a.remove();
      //*/
    },

    isLCInstrumentType(instrumentType) {
      const name = instrumentType?.name || '';
      return name === 'LC (支撐荷重計)' || (name.includes('LC') && name.includes('支撐荷重計'));
    },
    
    showVal(v, fallback = '-') {
      return (v === 0 || v) ? v : fallback; // 0 要顯示，不要被當成 false
    },

    /**
     * 驗證所有 enabled 的 rows
     * @returns {Object} { valid: boolean, errors: Array }
     */
    validateUploadData() {
      const errors = [];

      const hasEnabledRows = this.rows.some(row => row.enabled && row.timestamp);
      if (!hasEnabledRows) {
        this.validationErrors = [{
          type: 'NO_DATA',
          message: '沒有可上傳的資料',
        }];
        return {
          valid: false,
          errors: this.validationErrors,
        };
      }

      // 用於追蹤已出現的儀器(跨 row)
      const instrumentsAcrossRows = new Map(); // key: instrumentName, value: row index

      this.rows.forEach((row, rowIndex) => {
        // 只驗證 enabled 的 rows
        if (!row.enabled || !row.timestamp) return;

        const rowErrors = this.validateSingleRow(row, rowIndex);
        errors.push(...rowErrors);

        // 檢查跨 row 的重複
        if (row.reading && row.reading.length > 0) {
          row.reading.forEach((reading, readingIndex) => {
            if (!reading || !reading.instrument) return;

            const insName = reading.instrument.name;

            if (instrumentsAcrossRows.has(insName)) {
              errors.push({
                type: 'DUPLICATE_DATA',
                rowIndex,
                readingIndex,
                instrumentName: insName,
                message: `儀器 ${insName} 在多個資料表中重複出現 (第 ${instrumentsAcrossRows.get(insName) + 1} 個資料表 和 第 ${rowIndex + 1} 個資料表)`,
              });
            } else {
              instrumentsAcrossRows.set(insName, rowIndex);
            }
          });
        }
      });

      this.validationErrors = errors;

      return {
        valid: errors.length === 0,
        errors,
      };
    },

    hasError(rowIndex) {
      const hasErr = this.validationErrors.some(err => err.rowIndex === rowIndex);
  
      if (hasErr) {
        const errors = this.validationErrors.filter(err => err.rowIndex === rowIndex);
        console.log(`Row ${rowIndex} 有錯誤:`, errors);
      }

      return hasErr;
    },

    getRowErrorMessage(rowIndex) {
      const errors = this.validationErrors.filter(err => err.rowIndex === rowIndex);
      return errors.map(err => err.message).join('\n');
    },

    /**
     * 驗證單一 row
     * @param {Object} row 
     * @param {Number} rowIndex 
     * @returns {Array} errors
     */
    validateSingleRow(row, rowIndex) {
      const errors = [];

      if (!row.reading || row.reading.length === 0) {
        errors.push({
          type: 'NO_INSTRUMENTS',
          rowIndex,
          sheetName: row.sheetName,
          message: `資料表 "${row.sheetName}" 沒有任何儀器資料`,
        });
        return errors;
      }

      // 用於檢查同一個 row 內的重複
      const instrumentsInRow = new Set();

      row.reading.forEach((reading, readingIndex) => {
        if (!reading || !reading.instrument) {
          errors.push({
            type: 'MISSING_INSTRUMENT',
            rowIndex,
            readingIndex,
            sheetName: row.sheetName,
            message: `資料表 "${row.sheetName}" 第 ${readingIndex + 1} 個儀器資料缺失`,
          });
          return;
        }

        const insName = reading.instrument.name;

        // 檢查1: 同一 row 內重複
        if (instrumentsInRow.has(insName)) {
          errors.push({
            type: 'DUPLICATE_IN_ROW',
            rowIndex,
            readingIndex,
            instrumentName: insName,
            sheetName: row.sheetName,
            message: `資料表 "${row.sheetName}" 中儀器 ${insName} 重複出現`,
          });
        } else {
          instrumentsInRow.add(insName);
        }

        // 檢查2: 儀器是否存在於系統中
        const insExists = this.originInstrumentList.some(
          ins => ins.name === insName,
        );

        if (!insExists) {
          errors.push({
            type: 'INSTRUMENT_NOT_FOUND',
            rowIndex,
            readingIndex,
            instrumentName: insName,
            sheetName: row.sheetName,
            message: `儀器 ${insName} 不存在於系統中`,
          });
        }
      });

      return errors;
    },

    /**
     * 格式化錯誤訊息供使用者查看
     * @param {Array} errors 
     * @returns {String}
     */
    formatValidationErrors(errors) {
      if (errors.length === 0) return '';

      const errorsByType = {
        DUPLICATE_IN_ROW: [],
        DUPLICATE_DATA: [],
        INSTRUMENT_NOT_FOUND: [],
        MISSING_INSTRUMENT: [],
        NO_INSTRUMENTS: [],
        NO_DATA: [],
      };

      errors.forEach(err => {
        if (errorsByType[err.type]) {
          errorsByType[err.type].push(err);
        }
      });

      let message = `發現 ${errors.length} 個錯誤:\n\n`;

      // NO_DATA
      if (errorsByType.NO_DATA.length > 0) {
        message += '❌ 沒有可上傳的資料\n\n';
      }

      // DUPLICATE_IN_ROW
      if (errorsByType.DUPLICATE_IN_ROW.length > 0) {
        message += '❌ 同一資料表內有重複的儀器:\n';
        errorsByType.DUPLICATE_IN_ROW.forEach(err => {
          message += `  • ${err.sheetName}: ${err.instrumentName}\n`;
        });
        message += '\n';
      }

      // DUPLICATE_DATA
      if (errorsByType.DUPLICATE_DATA.length > 0) {
        message += '❌ 不同資料表間有重複的儀器:\n';
        const seen = new Set();
        errorsByType.DUPLICATE_DATA.forEach(err => {
          if (!seen.has(err.instrumentName)) {
            message += `  • ${err.instrumentName}\n`;
            seen.add(err.instrumentName);
          }
        });
        message += '\n';
      }

      // INSTRUMENT_NOT_FOUND
      if (errorsByType.INSTRUMENT_NOT_FOUND.length > 0) {
        message += '❌ 以下儀器不存在於系統中:\n';
        const seen = new Set();
        errorsByType.INSTRUMENT_NOT_FOUND.forEach(err => {
          if (!seen.has(err.instrumentName)) {
            message += `  • ${err.instrumentName} (於 ${err.sheetName})\n`;
            seen.add(err.instrumentName);
          }
        });
        message += '\n';
      }

      // NO_INSTRUMENTS
      if (errorsByType.NO_INSTRUMENTS.length > 0) {
        message += '❌ 以下資料表沒有儀器資料:\n';
        errorsByType.NO_INSTRUMENTS.forEach(err => {
          message += `  • ${err.sheetName}\n`;
        });
        message += '\n';
      }

      message += '\n請修正後再重新上傳';

      return message;
    },
  },
};
</script>

<style scoped>
.button-container {
  display: flex; /* 啟用 Flexbox */
  align-items: center; /* 垂直置中 */
  justify-content: flex-start; /* 控制子元素之間的間距 */
  gap: 10px; /* 子元素之間的間距 */
  flex-direction: row;
}

.warning-cell {
  background: #ff7575;
}
</style>

<style>
.el-table .error-row {
  background: #ffebee !important;
}

.el-table tr.error-row:hover > td {
  background: #ffc6ce !important;
}
</style>